import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { Investment } from "@rentablo/api/apiv1";
import { Banner } from "@rentablo/components";
import { useIsinValidation } from "@hooks";

interface Props {
  investmentId: number;
  investment?: Investment;
}

export const InvestmentIsinBanner = ({ investmentId, investment }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isIsinRequired, isIsinValid } = useIsinValidation(investment ?? {});

  if (!investment || !isIsinRequired || isIsinValid) {
    return null;
  }

  return (
    <Box px={6}>
      <Banner
        displayDefaultIcon
        type="error"
        title={t("investment.isinMissing.title")}
        text={t("investment.isinMissing.subtitle")}
        primaryButton={{
          label: t("investmentEditPage.tabs.advanced"),
          onClick: () =>
            navigate(`/investments/${investmentId}/edit?tab=advanced`),
        }}
        mb={4}
      />
    </Box>
  );
};
